// /agent-keys — «Ключи агента» (005, T033): выдача, отзыв и список ключей MCP-доступа. Право —
// agent_keys.manage (администратор клиента). Поиск и состояние — в адресе: /agent-keys?q=&state=.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { AgentKeysPage } from '../../../features/agent-keys/AgentKeysPage.tsx';
import { parseAgentKeysSearch } from '../../../features/agent-keys/search.ts';
import type { AgentKeysSearch } from '../../../features/agent-keys/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/agent-keys')({
  validateSearch: parseAgentKeysSearch,
  beforeLoad: requireSection('agentKeys'),
  staticData: { crumb: 'Ключи агента' },
  component: AgentKeysRoute,
});

function AgentKeysRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: AgentKeysSearch) => void navigate({ to: '/agent-keys', search: next, replace: true }),
    [navigate],
  );
  return <AgentKeysPage search={search} onSearchChange={onSearchChange} />;
}
